var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 437,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F87C56",
    d: "M48 278h18V0H48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-349.999 345.526h227.176v73.437a.284.284 0 00.284.285H-8.492v17.638h-114.047a17.94 17.94 0 01-17.923-17.923v-55.798h-209.537v-17.639zm348.934 24.458h-72.228a17.628 17.628 0 00-17.612 17.611v24.453H41.252l.194-107.853h7.096v107.853H95v-17.639H66.18V286.556H23.84l-.194 107.853h-96.91v-6.786h89.67l1.043-108.55H66.18v-17.639H-.023l-1.042 108.55zm-348.934-31.391h323.868l.119 6.912h-89.728v66.579h17.639v-48.94H-8.07l-.721-42.189H-350v17.638z",
    fill: "#F87C56"
  })));
}
export default SvgIconPatternFour;